export const LANGUAGE_OPTIONS = [
  {
    code: 'pt-BR',
    flag: '\uD83C\uDDE7\uD83C\uDDF7',
    accessibilityLabel: 'Portugu\u00EAs Brasil',
  },
  {
    code: 'en',
    flag: '\uD83C\uDDFA\uD83C\uDDF8',
    accessibilityLabel: 'English United States',
  },
  {
    code: 'es',
    flag: '\uD83C\uDDEA\uD83C\uDDF8',
    accessibilityLabel: 'Espa\u00F1ol Espa\u00F1a',
  },
];

export const getSelectedLanguage = (language) => {
  if (language?.startsWith('en')) return 'en';
  if (language?.startsWith('es')) return 'es';
  return 'pt-BR';
};

export const getLanguageOption = (language) => {
  const selectedLanguage = getSelectedLanguage(language);
  return LANGUAGE_OPTIONS.find((option) => option.code === selectedLanguage) || LANGUAGE_OPTIONS[0];
};

export const getNextLanguageCode = (language) => {
  const selectedLanguage = getSelectedLanguage(language);
  const currentIndex = LANGUAGE_OPTIONS.findIndex((option) => option.code === selectedLanguage);
  return LANGUAGE_OPTIONS[(currentIndex + 1) % LANGUAGE_OPTIONS.length].code;
};
